
const interserver = 'http://153.75.226.82:3000';
const s3Url_108and7 = '';//'https://108and7.s3.ap-south-1.amazonaws.com';
// const minioUrl_108and7 = 'http://153.75.226.82:9000/108and7';
const minioUrl_108and7 = 'https://goldenmemory108.in/minio/108and7';
const S3_USE_MINIO = true;//process.env.S3_USE_MINIO === 'true';
const config = {
    // API_URL: __DEV__ ? DEV_API_URL : PROD_API_URL,
    API_URL: interserver,//rootdomain, //AREALM_API_URL,
    // API_URL: AREALM_API_URL,
    ThumbUrl: S3_USE_MINIO ? minioUrl_108and7 : s3Url_108and7,
};

export default config;
